// Kyodan Custom AfterPay settings
function adjustAfterPay(){ 
  var AfterPayComponentRoot = document.querySelector('square-placement').shadowRoot;
  
  var AfterPayShadowOverride = document.createElement('style');
  AfterPayShadowOverride.innerHTML = '.afterpay-logo {vertical-align: bottom;}.afterpay-logo.brand-afterpay, .afterpay-logo.brand-afterpay svg {width: var(--logo-badge-width, 80px)}.afterpay-logo.compact-badge svg, .afterpay-logo.compact-badge{height: calc(0.19*var(--logo-badge-width,86px) + 0px);}';
  AfterPayComponentRoot.appendChild(AfterPayShadowOverride);
}

// MutationObserver didn't get the double nested ShadowDOM, so waiting for everything
window.onload = (event) => {
  adjustAfterPay();
};